import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { LinkButton, Link } from 'core/components';
import PropTypes from 'prop-types';

@inject('$auth', '$alerting')
@observer
class PolicyLink extends Component {
  static propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
  };

  static defaultProps = {
    children: 'Configure Policy'
  };

  get canEditPolicy() {
    const { $auth } = this.props;

    return $auth.hasRbacPermissions(['alerting.policies::update']);
  }

  render() {
    const { $auth, $alerting, as, children, id, model, tab, ...rest } = this.props;

    if ($auth.isDemoUser) {
      return null;
    }

    const policyModel = model || (id && $alerting.policyCollection.get(id));

    if (!policyModel) {
      return children || id || 'Missing Policy';
    }

    let to;
    let state = {};

    if (this.canEditPolicy) {
      to = policyModel.manageUrl;
      state.selectedTabId = tab;
    } else {
      to = '/v4/alerting/policies';
      state = { filters: { id: policyModel.id || id } };
    }

    const LinkComponent = as === 'Button' ? LinkButton : Link;

    return (
      <LinkComponent to={to} state={state} {...rest}>
        {children}
      </LinkComponent>
    );
  }
}

export default PolicyLink;
